export const SUPPORTED_LANGUAGES = [
  {
    code: "si",
    label: "සිංහල",
    englishLabel: "Sinhala",
    display: "සිංහල (Sinhala)",
    brandTransliteration: null,
    badge: null,
    disabled: false,
  },
  {
    code: "en",
    label: "English",
    englishLabel: "English",
    display: "English",
    brandTransliteration: "Lak Handahana",
    badge: null,
    disabled: false,
  },
  {
    code: "ta",
    label: "தமிழ்",
    englishLabel: "Tamil",
    display: "தமிழ் (Tamil)",
    brandTransliteration: "லக் ஹந்தஹன",
    badge: null,
    disabled: false,
  },
  {
    code: "hi",
    label: "हिन्दी",
    englishLabel: "Hindi",
    display: "हिन्दी (Hindi)",
    brandTransliteration: "लक हंदहना",
    badge: null,
    disabled: false,
  },
];

export const DEFAULT_LANGUAGE = "si";

export function getLanguageConfig(code) {
  const normalized = (code || "").split("-")[0].toLowerCase();
  return (
    SUPPORTED_LANGUAGES.find((lang) => lang.code === normalized) ||
    SUPPORTED_LANGUAGES[0]
  );
}
